module.exports = __webpack_public_path__ + "img/golf.7102ffb0.svg";